import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class RedirectMitec2Guard implements CanActivate, CanActivateChild {

  constructor(private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    this.showRedirectModal();
    return false;
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    this.showRedirectModal();
    return false;
  }

  private showRedirectModal(): void {
    Swal.fire({
      title: 'Aviso importante',
      html: 'Para acceder a este módulo se debe hacer desde <a href="https://mitec2.ittepic.edu.mx/" target="_blank" style="font-weight: bold; color: #183969; text-decoration: underline;">MiTec 2</a> con los mismos accesos.',
      type: 'info',
      showCancelButton: true,
      confirmButtonText: 'Ir a MiTec 2',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#183969',
      cancelButtonColor: '#6c757d',
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then((result) => {
      if (result.value) {
        window.open('https://mitec2.ittepic.edu.mx/', '_blank');
      }
      this.router.navigate(['/']);
    });
  }
}
